import {
  type MessageHandler,
  useNativeMessageListener as useNativeMessagePackageListener
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import { isNonProd } from '~/constants/environment';
import ErrorContext from '~/context/common/ErrorContext';
import { generateErrorLogger } from '~/utilities/loggers';
import {
  useAddFavoriteHandler,
  useCloseModalHandler,
  useOnLoadHandler,
  useRemoveFavoriteHandler,
  useSebsReadinessHandler,
  useStartPreOrderHandler,
  useStartPurchaseHandler
} from './handlers';
import { ListenerEvent, type ListenerEventType } from './handlers/constants';
import {
  useErrorHandler,
  useUpdateGeolocationHandler
} from '../common/handlers';

export default function useNativeMessageListener() {
  const { setNativeError } = useContext(ErrorContext);
  const addFavoriteHandler = useAddFavoriteHandler();
  const closeModalHandler = useCloseModalHandler();
  const errorHandler = useErrorHandler<ListenerEventType>();
  const onLoadHandler = useOnLoadHandler();
  const removeFavoriteHandler = useRemoveFavoriteHandler();
  const sebsReadinessHandler = useSebsReadinessHandler();
  const startPreOrderHandler = useStartPreOrderHandler();
  const startPurchaseHandler = useStartPurchaseHandler();
  const updateGeolocationHandler =
    useUpdateGeolocationHandler<ListenerEventType>();

  const handlers = useMemo<Array<MessageHandler<ListenerEventType, any>>>(
    () => [
      addFavoriteHandler,
      closeModalHandler,
      errorHandler,
      onLoadHandler,
      removeFavoriteHandler,
      sebsReadinessHandler,
      startPreOrderHandler,
      startPurchaseHandler,
      updateGeolocationHandler
    ],
    [
      addFavoriteHandler,
      closeModalHandler,
      errorHandler,
      onLoadHandler,
      removeFavoriteHandler,
      sebsReadinessHandler,
      startPreOrderHandler,
      startPurchaseHandler,
      updateGeolocationHandler
    ]
  );

  useNativeMessagePackageListener<ListenerEventType>({
    handlers,
    knownEvents: ListenerEvent,
    logErrorToTelemetry: generateErrorLogger('VDP native message listener'),
    logErrorToUser(_err) {
      setNativeError(new Error('Something went wrong. Please try again.'));
    },
    verboseLogs: isNonProd
  });
}
